export default "__VITE_ASSET__D3P4T4O7__"